<template>
  <div class="modal-video">
    <div class="modal-video__content">
      <button type="button" class="modal-video__overlay" @click="hideModal"></button>
      <div class="modal-video__wrap">
        <div class="modal-video__frame" v-if="file">
          <video controls autoplay>
            <source :src="file" :type="type">
          </video>
        </div>
        <div class="modal-video__frame" v-else-if="vk">
          <iframe :src="src"
                  title="VK video player"
                  allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameBorder="0"
                  allowFullScreen></iframe>
        </div>
        <div class="modal-video__frame" v-else-if="rutube">
          <iframe :src="src"
                  title="Rutube video player"
                  frameBorder="0" allow="clipboard-write; autoplay"
                  webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
        </div>
        <div class="modal-video__frame" v-else-if="src">
          <iframe
              :src="src"
              title="YouTube video player" frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write;
             encrypted-media; gyroscope; picture-in-picture;"
              allowFullScreen></iframe>
        </div>
      </div>
    </div>

    <button type="button" class="modal-video__close" @click="hideModal">
      <Icon name="24/cross"/>
    </button>
  </div>
</template>

<script>
import Icon from '@/components/Icon/Icon.vue';

export default {
  name: 'ModalVideo',
  components: { Icon },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    src() {
      if (this.data.src && this.data.src.includes('youtube')) {
        const embedUrl = 'https://www.youtube.com/embed/';
        const link = this.data.src.match(/v=([^&]+)/)[1];
        return `${embedUrl}${link}`;
      }
      return this.data.src;
    },
    file() {
      return this.data.file?.src ? `${process.env.VUE_APP_API_URL}${this.data.file.src}` : null;
    },
    type() {
      return this.data.file?.type ? this.data.file.type : null;
    },
    vk() {
      return this.data.src.includes('vk.com');
    },
    rutube() {
      return this.data.src.includes('rutube.ru');
    },
  },
  methods: {
    hideModal() {
      this.$emit('hideModal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "ModalVideo";
</style>
